export default {
  // 新增粮油规格
  insertYxOilSpec: '/ygsjzs/yxOilSpec/insertYxOilSpec',
  // 修改粮油规格
  updateYxOilSpec: '/ygsjzs/yxOilSpec/updateYxOilSpec',
  // 删除粮油规格
  deleteYxOilSpec: '/ygsjzs/yxOilSpec/deleteYxOilSpec',
  // 查询粮油规格详情
  selectYxOilSpecBySpecId: '/ygsjzs/yxOilSpec/selectYxOilSpecBySpecId',
  // 查询粮油规格列表
  selectYxOilSpecByList: '/ygsjzs/yxOilSpec/selectYxOilSpecByList',

  // 查询滚动文字
  selectYxGdx: '/ygsjzs/YxGdx/selectYxGdx',
  // 修改
  updateYxGdx: '/ygsjzs/YxGdx/updateYxGdx'

}
